import {
  ChallengeDto,
  LicenseValidatorPublicKey,
  SignedChallengeDTO,
} from 'business/models/Models';
import { utilityConfig, UtilityEndpoints } from './config';
import { getConfig } from 'config';

const getLicenseValidatorBaseUrl = (): string => {
  const config = getConfig();
  const licenseValidatorBaseUrl = `${utilityConfig.protocol}://${utilityConfig.host}:${config.LicenseAuthenticatorPort}`;
  return licenseValidatorBaseUrl;
};

// ---------- Internal helper ----------
async function utilityFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), utilityConfig.timeoutMs);

  try {
    const res = await fetch(`${getLicenseValidatorBaseUrl()}${path}`, {
      ...options,
      signal: controller.signal,
    });

    if (!res.ok) {
      throw new Error(`Utility error (${res.status})`);
    }

    return (await res.json()) as T;
  } finally {
    clearTimeout(timeoutId);
  }
}

// ---------- Public API ----------
export const licenseValidatorApi = {
  getPublicKey(): Promise<LicenseValidatorPublicKey> {
    return utilityFetch<LicenseValidatorPublicKey>(UtilityEndpoints.publicKey);
  },

  signChallenge(payload: ChallengeDto): Promise<SignedChallengeDTO> {
    return utilityFetch<SignedChallengeDTO>(UtilityEndpoints.getPcInfo, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  },

  getHealth(): Promise<HealthStatus> {
    return utilityFetch<HealthStatus>(UtilityEndpoints.health);
  },
};

export interface HealthStatus {
  status: string;
}
